/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { SanitizedHtml } from 'framework/utils';
import { Container, Typography } from '@mui/material';
import { useAuthorizationAuth } from '../authorization/AuthorizationAuthContext';

interface Page451Props {
  location?: {
    state?: {
      htmlMessage?: string;
    };
  };
}

const Page451 = (props: Page451Props) => {
  const { location } = props;
  const { isAuthenticated, backLinkLabel } = useAuthorizationAuth();

  const getDefaultPageMessage = () => {
    return (
      <>
        Most likely, this page was removed in order to comply with personal data protection laws.
        {isAuthenticated && (
          <>
            <br />
            You can go back to&nbsp;
            <Link to="/">{backLinkLabel}</Link>
          </>
        )}
      </>
    );
  };

  const getPageMessage = () => {
    if (location?.state?.htmlMessage) {
      return <SanitizedHtml html={location.state.htmlMessage} />;
    } else {
      return getDefaultPageMessage();
    }
  };

  return (
    <Container
      sx={{
        justifyContent: 'center',
        minHeight: 'calc(100vh - 90px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="display0" sx={{ float: 'left' }} mr={3.75} color="primary">
        451
      </Typography>
      <div>
        <Typography variant="h4" mb={1} pt={1.5}>
          Unavailable for legal reasons.
        </Typography>
        <Typography color="textSecondary">{getPageMessage()}</Typography>
      </div>
    </Container>
  );
};

export default Page451;
